import React from "react";
import { Tooltip } from "antd";

interface PermissionWrapperProps {
  hasPermissions: boolean;
  tooltip?: string;
  htmlTooltip?: boolean;
  children: React.ReactElement;
}

const PermissionWrapper: React.FC<PermissionWrapperProps> = ({
  hasPermissions,
  tooltip = "You are not authorized to perform this action",
  htmlTooltip = false,
  children,
}) => {
  if (hasPermissions) return children;

  const disabledChild = React.cloneElement(children, {
    open: false,
    disabled: true,
  });

  if (htmlTooltip) {
    return (
      <div
        title={tooltip}
        style={{
          display: "inline-block",
          width: "100%",
          cursor: "not-allowed",
        }}
      >
        <div style={{ pointerEvents: "none" }}>{disabledChild}</div>
      </div>
    );
  }

  return (
    <Tooltip
      title={tooltip}
      overlayStyle={{ zIndex: 999999999 }}
      color={"var(--tertiary-color)"}
    >
      <div
        style={{
          display: "inline-block",
          cursor: "not-allowed",
        }}
      >
        <div
          style={{
            pointerEvents: "none",
          }}
        >
          {disabledChild}
        </div>
      </div>
    </Tooltip>
  );
};

export default PermissionWrapper;
